import { UseQueryOptions } from '@tanstack/react-query';
import { CohortList } from 'domains/segments/types';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';

type UseSegmentCohortsParams = {
    limit?: number;
    offset?: number;
    searchTerm?: string;
    reactQueryOptions?: UseQueryOptions<CohortList, Error>;
};

const useSegmentCohorts = ({ limit = 50, offset = 0, searchTerm, reactQueryOptions }: UseSegmentCohortsParams = {}) => {
    // Build query parameters object
    const params = {
        ...(limit && { limit }),
        ...(offset >= 0 && { offset }),
        ...(searchTerm && { searchTerm }),
    };

    // Build axios options with params if any exist
    const axiosOptions = {
        ...(Object.keys(params).length > 0 && { params }),
    };

    return useQuery<CohortList>(
        QueryKeys.SEGMENT_COHORTS(limit, offset, searchTerm),
        `${CuredApiPaths.SEGMENTS}/cohorts`,
        reactQueryOptions,
        axiosOptions
    );
};

export default useSegmentCohorts;
